import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "mx-auto"
};
const _hoisted_2 = {
  class: "absolute top-0 left-0 right-0 h-[50px] bg-white border-bottom z-10 flex items-center px-[20px]"
};
const _hoisted_3 = {
  class: "w-[200px] flex items-center overflow-hidden"
};
const _hoisted_4 = {
  class: "ml-[10px] text-16px truncate"
};
const _hoisted_5 = {
  class: "flex-1 flex items-center justify-center h-full"
};
const _hoisted_6 = {
  class: "w-400px flex items-center justify-between h-full"
};
const _hoisted_7 = {
  class: "text-16px font-bold whitespace-nowrap"
};
const _hoisted_8 = {
  class: "mt-[50px]"
};
const _hoisted_9 = {
  key: 0,
  class: "mx-auto w-[560px]"
};
const _hoisted_10 = {
  key: 1,
  class: "mx-auto w-[560px]"
};
const _hoisted_11 = {
  key: 2,
  class: "mx-auto w-[560px]"
};
import UploadStep from './UploadStep.vue';
import SplitStep from './SplitStep.vue';
import ProcessStep from './ProcessStep.vue';
import { KnowledgeDocumentApi } from '@/api/ai/knowledge/document';
import { getCurrentInstance, provide, ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['onCreate'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const dialogVisible = ref(false); // 弹窗的是否展示
    const dialogTitle = ref(''); // 弹窗的标题
    // const { delView } = useTagsViewStore() // 视图操作
    // const route = useRoute() // 路由
    // const router = useRouter() // 路由
    const emit = __emit;
    // 组件引用
    const uploadDocumentRef = ref();
    const documentSegmentRef = ref();
    const processCompleteRef = ref();
    const currentStep = ref(0); // 步骤控制
    const steps = [{
      title: '上传文档'
    }, {
      title: '文档分段'
    }, {
      title: '处理并完成'
    }];
    const formData = ref({
      knowledgeId: undefined,
      // 知识库编号
      id: undefined,
      // 编辑的文档编号(documentId)
      segmentMaxTokens: 500,
      // 分段最大 token 数
      list: [] // 用于存储上传的文件列表
    }); // 表单数据
    provide('parent', getCurrentInstance()); // 提供 parent 给子组件使用
    const open = async (knowledgeId, id, title) => {
      dialogVisible.value = true;
      dialogTitle.value = title || '新增应用';
      initData(knowledgeId, id);
    };
    /** 初始化数据 */
    const initData = async (knowledgeId, id) => {
      // 【新增场景】从路由参数中获取知识库 ID
      // if (route.query.knowledgeId) {
      //   formData.value.knowledgeId = route.query.knowledgeId as any
      // }
      formData.value.knowledgeId = knowledgeId;
      // 【修改场景】从路由参数中获取文档 ID
      const documentId = id;
      if (documentId) {
        // 获取文档信息
        formData.value.id = documentId;
        const document = await KnowledgeDocumentApi.getKnowledgeDocument(documentId);
        formData.value.segmentMaxTokens = document.segmentMaxTokens;
        formData.value.list = [{
          id: document.id,
          name: document.name,
          url: document.url,
          segments: []
        }];
        // 进入下一步
        goToNextStep();
      }
    };
    /** 切换到下一步 */
    const goToNextStep = () => {
      if (currentStep.value < steps.length - 1) {
        currentStep.value++;
      }
    };
    /** 切换到上一步 */
    const goToPrevStep = () => {
      if (currentStep.value > 0) {
        currentStep.value--;
      }
    };
    /** 返回列表页 */
    const handleBack = () => {
      // // 先删除当前页签
      // delView(unref(router.currentRoute))
      // // 跳转到列表页
      // router.push({ name: 'AiKnowledgeDocument', query: { knowledgeId: formData.value.knowledgeId } })
      emit('onCreate');
      close();
    };
    function close() {
      dialogVisible.value = false;
      // 清理所有的引用
      uploadDocumentRef.value = null;
      documentSegmentRef.value = null;
      processCompleteRef.value = null;
    }
    /** 初始化 */
    // onMounted(async () => {
    //   await initData()
    // })
    /** 添加组件卸载前的清理代码 */
    // onBeforeUnmount(() => {
    //   // 清理所有的引用
    //   uploadDocumentRef.value = null
    //   documentSegmentRef.value = null
    //   processCompleteRef.value = null
    // })
    /** 暴露方法给子组件使用 */
    __expose({
      goToNextStep,
      goToPrevStep,
      handleBack,
      open
    });
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_ContentWrap = _resolveComponent("ContentWrap");
      const _component_Dialog = _resolveComponent("Dialog");
      return _openBlock(), _createBlock(_component_Dialog, {
        title: dialogTitle.value,
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dialogVisible.value = $event),
        width: "60%",
        maxHeight: "500px"
      }, {
        default: _withCtx(() => [_createVNode(_component_ContentWrap, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_Icon, {
            icon: "ep:arrow-left",
            class: "cursor-pointer flex-shrink-0",
            onClick: handleBack
          }), _createElementVNode("span", _hoisted_4, _toDisplayString(formData.value.id ? '编辑知识库文档' : '创建知识库文档'), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step, index) => {
            return _createElementVNode("div", {
              key: index,
              class: _normalizeClass(["flex items-center mx-[15px] relative h-full", [currentStep.value === index ? 'text-[#3473ff] border-[#3473ff] border-b-2 border-b-solid' : 'text-gray-500']])
            }, [_createElementVNode("div", {
              class: _normalizeClass(["w-[28px] h-[28px] rounded-full flex items-center justify-center mr-[8px] border-2 border-solid text-[15px]", [currentStep.value === index ? 'bg-[#3473ff] text-white border-[#3473ff]' : 'border-gray-300 bg-white text-gray-500']])
            }, _toDisplayString(index + 1), 3), _createElementVNode("span", _hoisted_7, _toDisplayString(step.title), 1)], 2);
          }), 64))])]), _cache[4] || (_cache[4] = _createElementVNode("div", {
            class: "w-[200px] flex items-center justify-end gap-2"
          }, null, -1))]), _createElementVNode("div", _hoisted_8, [currentStep.value === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(UploadStep, {
            modelValue: formData.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value = $event),
            ref_key: "uploadDocumentRef",
            ref: uploadDocumentRef
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), currentStep.value === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(SplitStep, {
            modelValue: formData.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value = $event),
            ref_key: "documentSegmentRef",
            ref: documentSegmentRef
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), currentStep.value === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(ProcessStep, {
            modelValue: formData.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value = $event),
            ref_key: "processCompleteRef",
            ref: processCompleteRef
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true)])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }
});